import {ISegmentationRightsService} from "@/modules/Segmentation/services/ISegmentationRightsService";
import {inject, injectable} from "tsyringe";
import {IAgentService} from "@/services/IAgentService";
import {IUserRoleService} from "@/services/IUserRoleService";
import {IStoreService} from "@/services/IStoreService";

@injectable()
export class SegmentationRightsService implements ISegmentationRightsService {
    constructor(
        @inject("IUserRoleService")
        private readonly roleService: IUserRoleService,
        @inject("IStoreService")
        private readonly storeService: IStoreService,
        @inject("IAgentService")
        private readonly agentService: IAgentService,
    ) {
    }

    async isAllowEdit(agentId: string): Promise<boolean> {
        let res = this.roleService.isAllowOtherSegmentationEdit;

        if (!res) {
            res = (this.storeService.currentAgent?.id === agentId || await this.agentService.isChild(agentId))
                && this.roleService.isAllowSegmentationEdit;
        }

        return res;
    }

    async isAllowRead(agentId: string): Promise<boolean> {
        let res = this.roleService.isAllowOtherSegmentationRead;

        if (!res) {
            res = (this.storeService.currentAgent?.id === agentId || await this.agentService.isChild(agentId))
                && this.roleService.isAllowSegmentationRead;
        }

        return res;
    }
}
